import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  const d = detail?.response?.data?.detail ?? detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  if (d?.message) return d.message;
  return String(d);
}

export async function downloadFile(path, fallbackName) {
  const fetchBlob = () => api.get(path, { responseType: "blob", timeout: 90000 });
  let res;
  try {
    res = await fetchBlob();
  } catch (first) {
    const status = first?.response?.status || 0;
    // Cold renders can hit the edge timeout (502/504/524). One retry lands on a warm browser.
    if (status === 0 || status >= 500) {
      await new Promise((r) => setTimeout(r, 1500));
      try {
        res = await fetchBlob();
      } catch {
        throw new Error("The file is taking longer than usual to generate. Please try again in a few seconds.");
      }
    } else {
      throw first;
    }
  }
  const { data, headers } = res;
  const match = /filename="?([^"]+)"?/.exec(headers["content-disposition"] || "");
  const name = match ? match[1] : fallbackName;
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
